<template>
  <div>
    <el-row>
      <el-button type="primary" @click="add"
                 v-if="btnInList('idc_add')">新增IDC
      </el-button>
      <el-button v-if="btnInList('idc_import')">导入</el-button>
      <el-button v-if="btnInList('idc_export')">导出</el-button>
      <el-button type="primary" @click="pubNetPlane()"
                 v-if="btnInList('idc_pubNetMan')">共有网络平面管理
      </el-button>
      <el-button type="primary" @click="groupInfo()"
                 v-if="btnInList('idc_groupInfo')">Group信息管理
      </el-button>
      <el-button type="primary" @click="platMapInfo()"
                 v-if="btnInList('idc_platMap')">平台网络映射信息
      </el-button>
      <el-dropdown @command="handleCommand" style="margin-left: 10px" trigger="click"
                   v-if="btnInList('idc_downloadConfig')">
        <el-button type="primary">
          下载配置文件<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown placement="right-start" trigger="click" @command="downSingleFileCommand">
            <el-dropdown-item style="width: 122%" @click.native="getSingleFileList">下载单个配置文件</el-dropdown-item>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in singleFileData"
                :key="index"
                :command="item">
                {{ item + "NodeInfoCfg.yml" }}
              </el-dropdown-item>
              <!--                <el-dropdown-item command="e">STPNodeInfoCfg.yml</el-dropdown-item>-->
              <!--                <el-dropdown-item command="f">relayrcNodeInfoCfg.yml</el-dropdown-item>-->
              <!--                <el-dropdown-item command="g">RelayNodeInfoCfg.yml</el-dropdown-item>-->
              <!--                <el-dropdown-item command="h">DetectBaseAsyMoudelNodeInfoCfg.yml</el-dropdown-item>-->
              <!--                <el-dropdown-item command="i">qos_receiverNodeInfoCfg.yml</el-dropdown-item>-->
              <!--                <el-dropdown-item command="j">MPU_ServerNodeInfoCfg.yml</el-dropdown-item>-->
              <!--                <el-dropdown-item command="k">FusionServerNodeInfoCfg.yml</el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown-item command="a">ServerNodeInfoCfg配置文件</el-dropdown-item>
          <el-dropdown-item command="b">BusinessTypeTransition.yml</el-dropdown-item>
          <el-dropdown-item command="c">NetAccessbilityCfg.yml</el-dropdown-item>
          <el-dropdown-item command="d">GroupRouterStrategy.yml</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" style="margin-left: 10px" v-if="btnInList('agent_batch_upgrade')"
                 @click="goUpdate">Agent一键升级
      </el-button>
      <el-button type="danger" style="margin-left: 10px" v-if="btnInList('idc_sync')"
                 @click="syncConfirm">同步
      </el-button>
      <el-tooltip content="ButelProxy完整性验证" effect="light" placement="top-start">
        <el-button type="danger" style="margin-left: 10px" v-if="btnInList('idc_verify')"
                   @click="verifyProxy">校验
        </el-button>
      </el-tooltip>


      <el-input placeholder="搜索" clearable v-model="condition" style="width: 300px;margin-right:10px;float: right">
        <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
      </el-input>
    </el-row>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="id" label="ID" width="130"></el-table-column>
      <el-table-column align="center" prop="idcName" label="IDC名称"></el-table-column>
      <el-table-column align="center" label="地域">
        <template v-slot="{row}">
          {{ showArea(row) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createDate" label="创建时间" width="180"></el-table-column>
      <el-table-column align="center" label="操作" width="700">
        <template v-slot="{row}">
          <el-button size="mini" type="primary" @click="devMan(row.id)"
                     v-if="btnInList('idc_device')">设备管理
          </el-button>
          <el-button size="mini" type="primary" @click="publicIpAddr(row.id)"
                     v-if="btnInList('idc_pubIpAddr')">公网IP地址
          </el-button>
          <el-button size="mini" type="primary" @click="privateNetPlane(row.id)"
                     v-if="btnInList('idc_priNetPlane')">私有网络平面
          </el-button>
          <el-button size="mini" type="primary" @click="editIdc(row.id)"
                     v-if="btnInList('idc_edit')">编辑
          </el-button>
          <el-button size="mini" type="danger" @click="delConfirm(row.id)"
                     v-if="btnInList('idc_del')">删除
          </el-button>
          <el-button size="mini" type="primary" @click="butelProxyMan(row.id)"
                     v-if="btnInList('idc_butelproxy')">ButelProxy管理
          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <Idc-edit v-if="showEdit" :visible="showEdit" :id="id"
              @editCallback="editCallback"/>

    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>

  </div>
</template>

<script>
import IdcEdit from './IdcEdit.vue'
import {mapMutations, mapState} from "vuex";

export default {
  name: "IdcList",
  components: {IdcEdit},
  data() {
    return {
      showEdit: false, //新增窗口
      downloadList: false,
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      condition: "",
      isPassCurrentPage: "",
      showSync: "",
      id: null,
      tableData: [],
      singleFileData: [],
    }
  },
  mounted: function () {
    window.verifyJump = this.verifyJump;
  },

  methods: {
    ...mapMutations(['getListOperations']),
    goUpdate() {
      this.$router.push({
        name: "updateagent"
      })
    },
    searchClick() {
      this.currentPage = 1;
      this.initIdcList()
    },
    verifyJump() {
      let routeUrl = this.$router.resolve({
        path: "/container/idc/butelproxylist/0/2"
      });
      window.open(routeUrl.href, '_blank');
    },
    async verifyProxy() {
      this.$axios.get(this.baseUrl3 + 'management3/proxy/integrity/verify')
        .then(({data: {code, data, msg}}) => {
          this.$notify.closeAll();
          if (code == 20000) {
            if (data && data.length > 0) {
              this.$notify({
                position: 'bottom-right',
                dangerouslyUseHTMLString: true,
                message: '<div>校验完成，点击<span  onclick="verifyJump()" style="color:#1d8def; text-decoration: none; cursor: pointer;">跳转</span></div>',
                duration: 0,//是否自动关闭
                customClass: 'notifyStyle',
                showClose: false//不显示右上角关闭按钮
              });
              this.verifyData = data;
              localStorage.setItem('VerifyData', JSON.stringify(data))
            } else {
              this.$message.success('校验完成,比较一致！')
            }
          } else {
            this.$message.error('校验失败! ' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    getSingleFileList() {
      this.$axios.get(this.baseUrl3 + 'management3/config/canObtain/servernode')
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.singleFileData = data;
          } else {
            this.$message.error('操作失败,' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    syncConfirm() {
      this.$confirm('当前操作会将配置文件 NodeInfoCfg.yml同步至上线的relayrc与GatewayRC实例，将覆盖已有的NodeInfoCfg 配置文件，是否继续?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
        customClass: "warnClass",
        center: true,
        showClose: false
      }).then(() => {
        this.syncNodeInfo();
      }).catch(() => {

      });
    },
    syncNodeInfo() {
      this.$axios.get(this.baseUrl3 + 'management3/config/syncNodeInfo')
        .then(({data: {code, data, msg}}) => {
          if (code == 20000) {
            this.showSync = data.join('<br/>');
            this.$message({
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: this.showSync,
                type: 'success'
              }
            )
          } else {
            this.$message.error('操作失败,' + msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleCommand(command) {
      if (command == 'a') {
        this.downNode()
      } else if (command == 'b') {
        this.downBusinesstype()
      } else if (command == 'c') {
        this.downNetplaneaccess()
      } else if (command == 'd') {
        this.downStrategy()
      }
    },
    downSingleFileCommand(moudletype) {
      if (moudletype) {
        let url = this.baseUrl3 + 'management3/config/selectgenerateservernode/' + moudletype
        this.$axios({
          method: 'get',
          url: url,
          responseType: 'blob',
          headers: {
            'Authorization': 'Bearer ' + this.token // 在请求头里加鉴权
          }
        }).then(response => {
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'filename';
          if (contentDisposition) {
            const matches = contentDisposition.split('filename=');
            if (matches.length > 1) {
              fileName = matches[1].replace(/"/g, '');
            }
          }
          const blob = new Blob([response.data], {type: response.headers['content-type']});
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = downloadUrl;
          a.download = fileName; // 从响应头中获取文件名
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(downloadUrl);
        }).catch(err => {
          console.log(err);
        });
        // this.$axios.get(this.baseUrl3 + 'management3/config/selectgenerateservernode/' + moudletype)
        //   .then(({data: {code, data, msg}}) => {
        //     if (code == 20000) {
        //       // var elemIF = document.createElement('iframe');
        //       // if (that.nginxUrl) {
        //       //   elemIF.src = this.nginxUrl + data;
        //       // } else {
        //       //   elemIF.src = data;
        //       // }
        //       // elemIF.style.display = 'none';
        //       document.body.appendChild(elemIF);
        //     } else {
        //       this.$message.error('操作失败,' + msg)
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err)
        //   })
      }
    },
    download() {
      this.downloadList = true
    },
    close() {
      this.downloadList = false;
    },
    downNode() {
      let url = this.baseUrl3 + 'management3/config/generateservernode'
      this.$axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: {
          'Authorization': 'Bearer ' + this.token // 在请求头里加鉴权
        }
      }).then(response => {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'filename';
        if (contentDisposition) {
          const matches = contentDisposition.split('filename=');
          if (matches.length > 1) {
            fileName = matches[1].replace(/"/g, '');
          }
        }
        const blob = new Blob([response.data], {type: response.headers['content-type']});
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName; // 从响应头中获取文件名
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      }).catch(err => {
        console.log(err);
      });
    },
    downBusinesstype() {
      let url = this.baseUrl3 + 'management3/config/generatebusinesstypeurl'
      this.$axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: {
          'Authorization': 'Bearer ' + this.token // 在请求头里加鉴权
        }
      }).then(response => {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'filename';
        if (contentDisposition) {
          const matches = contentDisposition.split('filename=');
          if (matches.length > 1) {
            fileName = matches[1].replace(/"/g, '');
          }
        }
        const blob = new Blob([response.data], {type: response.headers['content-type']});
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName; // 从响应头中获取文件名
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      }).catch(err => {
        console.log(err);
      });
    },
    downNetplaneaccess() {
      let url = this.baseUrl3 + 'management3/config/generatenetplaneaccess'
      this.$axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: {
          'Authorization': 'Bearer ' + this.token // 在请求头里加鉴权
        }
      }).then(response => {

        const contentDisposition = response.headers['content-disposition'];

        let fileName = 'filename';
        if (contentDisposition) {
          const matches = contentDisposition.split('filename=');
          if (matches.length > 1) {
            fileName = matches[1].replace(/"/g, '');
          }
        }
        const blob = new Blob([response.data], {type: response.headers['content-type']});
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName; // 从响应头中获取文件名
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      }).catch(err => {
        console.log(err);
      });
    },
    downStrategy() {
      let url = this.baseUrl3 + 'management3/config/generaterouterstrategy'
      this.$axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: {
          'Authorization': 'Bearer ' + this.token // 在请求头里加鉴权
        }
      }).then(response => {

        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'filename';
        if (contentDisposition) {
          const matches = contentDisposition.split('filename=');
          if (matches.length > 1) {
            fileName = matches[1].replace(/"/g, '');
          }
        }
        const blob = new Blob([response.data], {type: response.headers['content-type']});
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName; // 从响应头中获取文件名
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      }).catch(err => {
        console.log(err);
      });
    },
    editCallback(val) {
      if (val) {
        this.initIdcList();
      }
      this.showEdit = false
    },
    add() {
      this.id = null;
      this.showEdit = true;
    },
    editIdc(id) {
      this.id = id;
      this.showEdit = true
    },
    delConfirm(id) {
      this.$confirm('您确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delIdc(id)
      }).catch(() => {

      });
    },
    delIdc(id) {

      let data = {
        id: id
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/idc/del', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.initIdcList();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    devMan(id) {
      this.$router.push({
        path: 'idcdevicelist',
        name: 'idcdevicelist',
        params: {
          idcId: id,
          passIdcPage: this.currentPage
        }
      });
    },
    butelProxyMan(id) {
      this.$router.push({
        path: 'butelproxylist',
        name: 'butelproxylist',
        params: {
          idcId: id,
          flag: 1
        }
      });
    },
    publicIpAddr(id) {
      this.$router.push({
        path: 'publiciplist',
        name: 'publiciplist',
        params: {
          idcId: id
        }
      });
    },
    pubNetPlane() {
      this.$router.push({
        path: 'pubenetplane',
        name: 'pubenetplane'
      });
    },
    groupInfo() {
      this.$router.push({
        path: 'groupinfomanager',
        name: 'groupinfomanager'
      });
    },
    platMapInfo() {
      this.$router.push({
        path: 'platmapinfo',
        name: 'platmapinfo'
      });
    },
    privateNetPlane(id) {
      this.$router.push({
        path: 'privatenetplane',
        name: 'privatenetplane',
        params: {
          idcId: id
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.initIdcList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initIdcList()
    },
    initIdcList() {
      var data = {
        'pageNo': this.currentPage,
        'pageSize': this.pageSize,
        'condition': this.condition,
      };
      var _this = this;

      _this.tableData = [];
      this.$axios.post(this.baseUrl3 + 'management3/idc/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.tableData = data.idcList;
            _this.totalElement = data.total;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created() {
    this.getListOperations('idclist');
    if (!this.currentMenu) {
      return
    }
    // this.$router.push({query: {}});
    this.isPassCurrentPage = parseInt(this.$route.params.passCurrentPage);
    if (this.isPassCurrentPage) {
      this.currentPage = this.isPassCurrentPage
    }
    this.initIdcList();
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
        }

      }
    },
    showArea() {
      return function (row) {
        if (row.areaAllInfo.dNameDistricts) {
          return row.areaAllInfo.dNameCountry + "·" + row.areaAllInfo.dNameProvince + "·" + row.areaAllInfo.dNameCity + "·" + row.areaAllInfo.dNameDistricts
          // row.areaAllInfo.dNameContinent +"·"+
        }
        if (row.areaAllInfo.dNameCity) {
          return row.areaAllInfo.dNameCountry + "·" + row.areaAllInfo.dNameProvince + "·" + row.areaAllInfo.dNameCity
          // row.areaAllInfo.dNameContinent +"·"+
        }
        if (row.areaAllInfo.dNameProvince) {
          return row.areaAllInfo.dNameCountry + "·" + row.areaAllInfo.dNameProvince
          // row.areaAllInfo.dNameContinent +"·"+
        }
        if (row.areaAllInfo.dNameCountry) {
          return row.areaAllInfo.dNameCountry
          // row.areaAllInfo.dNameContinent +"·"+
        }
        if (row.areaAllInfo.dNameContinent) {
          return
          // row.areaAllInfo.dNameContinent
        }
        return
      }
    }
  }
}
</script>

<style>
.notifyStyle {
  width: auto;
}

.nested-dropdown-item:hover {
  background-color: rgb(236, 245, 255);
  width: 122%;
}

.warnClass {
  width: 350px !important;
  text-align: left !important;
}

.warnClass p {
  text-indent: 2em !important;
}

.warnClass .el-message-box__header {
  margin-top: -15px !important;
  margin-bottom: -10px !important;
}

/*.el-message-box__message{*/
/*  text-align: left !important;*/
/*  text-indent:2em !important;*/
/*}*/
/*.el-message-box__title{*/
/*  margin-top: -15px !important;*/
/*  margin-bottom: -10px !important;*/
/*}*/

</style>
